import styled from 'styled-components';
import Page from 'components/Page';
import { media } from 'utils/media';
import FormSection from 'views/ContactPage/FormSection';
import InformationSection from 'views/ContactPage/InformationSection';
import { ReCAPTCHAProvider } from 'contexts/ReCAPTCHAContext';

export default function ContactPage() {
  return (
    <ReCAPTCHAProvider>
        <Page
        isPublicPage
        navbar
        title="Contato"
        description="Entre em contato com o Nossa vaquinha!"
      >
        <ContactContainer>
          <InformationSection />
          <FormSection />
        </ContactContainer>
      </Page>
    </ReCAPTCHAProvider>
  );
}

const ContactContainer = styled.div`
  display: flex;
  background: #FBF9ED;

  ${media('<=tablet')} {
    flex-direction: column;
  }

  margin-top: 10rem;
`;
